import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CollapsibleHeader = ({ collapsibleAreaShown, setCollapsibleAreaShown, collapsibleHeaderText }) => (
  <React.Fragment>
    <button
      type="button"
      className="showhide-collapsible-button"
      onClick={ () => { setCollapsibleAreaShown(!collapsibleAreaShown); } }
    >
      <FontAwesomeIcon icon={ collapsibleAreaShown ? 'chevron-up' : 'chevron-down' } className="toggle-arrow" />
      {collapsibleHeaderText}
    </button>
  </React.Fragment>);

CollapsibleHeader.propTypes = {
  collapsibleAreaShown: PropTypes.bool,
  setCollapsibleAreaShown: PropTypes.func.isRequired,
  collapsibleHeaderText: PropTypes.string
};

CollapsibleHeader.defaultProps = {
  collapsibleAreaShown: false,
  collapsibleHeaderText: ''
};

export default CollapsibleHeader;
